(() => {
  const STYLE_ID = 'pampas-reviews-manual-design';
  const REVIEW_WIDGET_SELECTOR = [
    '.reputon-dual-row-carousel',
    '.reputon-carousel-holder',
    '[class*="reputon"][class*="carousel"]'
  ].join(',');

  const installStyles = () => {
    if (document.getElementById(STYLE_ID)) return;

    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = `
      .pampas-reviews-section {
        overflow: hidden !important;
        padding-block: clamp(30px, 5vw, 62px) !important;
        background: var(--pm-color-canvas-subtle, var(--pm-color-page)) !important;
      }
      .pampas-reviews-section .pampas-reviews-intro {
        width: min(1240px, calc(100% - 36px));
        margin: 0 auto 20px;
        direction: rtl;
        text-align: center;
      }
      .pampas-reviews-section .pampas-reviews-intro__eyebrow {
        display: inline-flex;
        align-items: center;
        gap: 7px;
        margin-bottom: 5px;
        color: var(--pm-color-primary);
        font-size: 14px;
        font-weight: 700;
      }
      .pampas-reviews-section .pampas-reviews-intro__eyebrow::before {
        content: none !important;
        display: none !important;
      }
      .pampas-reviews-section.pampas-reviews-native button[aria-label*='next' i],
      .pampas-reviews-section.pampas-reviews-native button[aria-label*='previous' i],
      .pampas-reviews-section.pampas-reviews-native button[aria-label*='הבא'],
      .pampas-reviews-section.pampas-reviews-native button[aria-label*='הקודם'],
      .pampas-reviews-section.pampas-reviews-native [class*='arrow' i] button,
      .pampas-reviews-section.pampas-reviews-native button[class*='arrow' i] {
        appearance: none !important;
        display: inline-flex !important;
        align-items: center !important;
        justify-content: center !important;
        width: var(--pm-icon-button-size, 44px) !important;
        min-width: var(--pm-icon-button-size, 44px) !important;
        height: var(--pm-icon-button-size, 44px) !important;
        min-height: var(--pm-icon-button-size, 44px) !important;
        padding: 0 !important;
        border: var(--pm-control-border-width, 1px) solid var(--pm-color-border) !important;
        border-radius: var(--pm-radius-pill, 999px) !important;
        background: var(--pm-color-surface-raised, var(--pm-color-page)) !important;
        color: var(--pm-color-primary) !important;
        box-shadow: var(--pm-shadow-small) !important;
        transform: none !important;
      }
      .pampas-reviews-section.pampas-reviews-native button[aria-label*='next' i]:hover,
      .pampas-reviews-section.pampas-reviews-native button[aria-label*='previous' i]:hover,
      .pampas-reviews-section.pampas-reviews-native [class*='arrow' i] button:hover,
      .pampas-reviews-section.pampas-reviews-native button[class*='arrow' i]:hover {
        border-color: var(--pm-color-primary) !important;
        background: var(--pm-color-primary) !important;
        color: var(--pm-color-on-primary) !important;
      }
      .pampas-reviews-section .pampas-reviews-intro h2 {
        margin: 0;
        color: var(--pm-color-text);
        font-size: clamp(29px, 3.2vw, 42px);
        line-height: 1.12;
      }
      .pampas-reviews-section .pampas-reviews-intro p {
        max-width: 620px;
        margin: 7px auto 0;
        color: var(--pm-color-text-muted);
        font-size: 16px;
        line-height: 1.5;
      }
      .pampas-reviews-section .reputon-header {
        box-sizing: border-box !important;
        width: min(1240px, calc(100% - 36px)) !important;
        max-width: 1240px !important;
        margin: 0 auto 18px !important;
        padding: 15px 18px !important;
        border: var(--pm-control-border-width) solid var(--pm-color-border) !important;
        border-radius: var(--pm-radius-medium) !important;
        background: color-mix(in srgb, var(--pm-color-surface) 76%, transparent) !important;
        box-shadow: var(--pm-shadow-small) !important;
      }
      .pampas-reviews-section.pampas-reviews-ready .reputon-dual-row-carousel,
      .pampas-reviews-section.pampas-reviews-ready .reputon-carousel-holder {
        position: absolute !important;
        width: 1px !important;
        height: 1px !important;
        overflow: hidden !important;
        clip: rect(0 0 0 0) !important;
        clip-path: inset(50%) !important;
        white-space: nowrap !important;
        pointer-events: none !important;
      }
      .pampas-reviews-manual {
        position: relative;
        box-sizing: border-box;
        width: min(1240px, calc(100% - 36px));
        margin-inline: auto;
        padding: 0;
        border: 0;
        border-radius: 0;
        background: transparent;
        box-shadow: none;
      }
      .pampas-reviews-manual::after {
        content: 'החליקו לצפייה בביקורות נוספות';
        display: block;
        margin-top: 12px;
        color: var(--pm-color-text-muted);
        font-size: 13px;
        text-align: center;
        direction: rtl;
      }
      .pampas-reviews-track {
        display: flex;
        width: 100%;
        gap: 14px;
        box-sizing: border-box;
        padding: 4px 2px 14px;
        overflow-x: auto;
        overflow-y: hidden;
        scroll-snap-type: x mandatory;
        scroll-padding-inline: 2px;
        overscroll-behavior-inline: contain;
        -webkit-overflow-scrolling: touch;
        touch-action: pan-x pan-y;
        scrollbar-width: thin;
        scrollbar-color: var(--pm-color-primary) var(--pm-color-surface-strong);
        cursor: grab;
        direction: ltr;
      }
      .pampas-reviews-track:active {
        cursor: grabbing;
      }
      .pampas-reviews-track::-webkit-scrollbar {
        height: 4px;
      }
      .pampas-reviews-track::-webkit-scrollbar-track {
        border-radius: var(--pm-radius-pill);
        background: var(--pm-color-surface-strong);
      }
      .pampas-reviews-track::-webkit-scrollbar-thumb {
        border-radius: var(--pm-radius-pill);
        background: var(--pm-color-primary);
      }
      .pampas-review-card {
        position: relative !important;
        display: flex !important;
        flex-direction: column !important;
        align-items: center !important;
        justify-content: center !important;
        flex: 0 0 calc((100% - 28px) / 3) !important;
        width: calc((100% - 28px) / 3) !important;
        min-width: calc((100% - 28px) / 3) !important;
        max-width: calc((100% - 28px) / 3) !important;
        height: auto !important;
        min-height: 230px !important;
        box-sizing: border-box !important;
        overflow: hidden !important;
        margin: 0 !important;
        border: var(--pm-control-border-width) solid var(--pm-color-border) !important;
        border-radius: var(--pm-radius-medium) !important;
        padding: clamp(16px, 1.8vw, 22px) !important;
        background: var(--pm-color-surface-raised, var(--pm-color-page)) !important;
        box-shadow: var(--pm-shadow-small) !important;
        scroll-snap-align: center;
        scroll-snap-stop: always;
        direction: rtl !important;
        text-align: center !important;
        transform: none !important;
        animation: none !important;
        opacity: 1 !important;
        pointer-events: auto !important;
      }
      .pampas-review-card,
      .pampas-review-card * {
        letter-spacing: 0 !important;
        text-align: center !important;
      }
      .pampas-review-card > * {
        width: 100% !important;
        margin-inline: auto !important;
      }
      .pampas-review-card div {
        justify-content: center !important;
        align-items: center !important;
        margin-inline: auto !important;
      }
      .pampas-review-card img {
        margin-inline: auto !important;
      }
      .pampas-review-card [class*='text' i],
      .pampas-review-card [class*='content' i] {
        line-height: 1.5 !important;
        text-align: center !important;
      }
      .pampas-review-card [class*='author' i],
      .pampas-review-card [class*='rating' i],
      .pampas-review-card [class*='star' i],
      .pampas-review-card [class*='reviewer' i] {
        justify-content: center !important;
        text-align: center !important;
        margin-inline: auto !important;
      }
      .pampas-review-card p {
        font-size: 14px !important;
        line-height: 1.6 !important;
      }
      .pampas-reviews-nav {
        display: grid !important;
        grid-template-columns: 44px auto 44px;
        align-items: center !important;
        justify-content: center !important;
        gap: 10px !important;
        width: max-content;
        margin: 8px auto 0 !important;
        direction: ltr !important;
      }
      .pampas-reviews-nav__button {
        appearance: none !important;
        display: inline-flex !important;
        align-items: center !important;
        justify-content: center !important;
        width: var(--pm-icon-button-size, 44px) !important;
        min-width: var(--pm-icon-button-size, 44px) !important;
        height: var(--pm-icon-button-size, 44px) !important;
        min-height: var(--pm-icon-button-size, 44px) !important;
        padding: 0 !important;
        margin: 0 !important;
        border: var(--pm-control-border-width, 1px) solid var(--pm-color-border) !important;
        border-radius: var(--pm-radius-pill, 999px) !important;
        background: var(--pm-color-surface-raised, var(--pm-color-page)) !important;
        color: var(--pm-color-primary) !important;
        box-shadow: var(--pm-shadow-small) !important;
        line-height: 1 !important;
        cursor: pointer !important;
        transition: background-color var(--pm-motion-fast, 160ms) ease, color var(--pm-motion-fast, 160ms) ease, border-color var(--pm-motion-fast, 160ms) ease;
      }
      .pampas-reviews-nav__button:hover:not(:disabled),
      .pampas-reviews-nav__button:focus-visible {
        border-color: var(--pm-color-primary) !important;
        background: var(--pm-color-primary) !important;
        color: var(--pm-color-on-primary) !important;
        transform: none !important;
      }
      .pampas-reviews-nav__button:focus-visible {
        outline: 2px solid var(--pm-color-focus, var(--pm-color-primary));
        outline-offset: 2px;
      }
      .pampas-reviews-nav__button:disabled {
        opacity: .38 !important;
        cursor: default !important;
      }
      .pampas-reviews-nav__button svg {
        display: block !important;
        width: 18px !important;
        height: 18px !important;
        margin: 0 !important;
        stroke: currentColor !important;
      }
      .pampas-reviews-status {
        min-width: 44px;
        color: var(--pm-color-text-muted);
        font-size: 13px;
        text-align: center;
        direction: ltr;
      }
      .pampas-review-photo {
        position: relative !important;
        overflow: hidden !important;
        border-radius: var(--pm-radius-small) !important;
      }
      .pampas-review-photo img {
        display: block !important;
        width: 100% !important;
        max-height: 150px !important;
        object-fit: cover !important;
      }
      .pampas-review-photo-badge {
        position: absolute;
        right: 7px;
        bottom: 7px;
        z-index: 3;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 31px;
        height: 31px;
        border: var(--pm-control-border-width) solid color-mix(in srgb, var(--pm-color-on-primary) 75%, transparent);
        border-radius: var(--pm-radius-pill);
        background: color-mix(in srgb, var(--pm-color-text) 84%, transparent);
        color: var(--pm-color-on-primary);
        pointer-events: none;
        -webkit-backdrop-filter: blur(7px);
        backdrop-filter: blur(7px);
      }
      .pampas-review-photo-badge svg {
        width: 16px;
        height: 16px;
      }
      .pampas-review-card.has-customer-photo::after {
        content: 'תמונת לקוחות';
        position: absolute;
        top: 9px;
        left: 9px;
        z-index: 4;
        padding: 5px 8px;
        border-radius: var(--pm-radius-pill);
        background: var(--pm-color-surface-strong);
        color: var(--pm-color-primary);
        font-size: 11px;
        font-weight: 700;
        line-height: 1;
        pointer-events: none;
      }
      @media (max-width: 749px) {
        .pampas-reviews-section {
          padding-block: 28px 34px !important;
        }
        .pampas-reviews-section .pampas-reviews-intro {
          width: calc(100% - 32px);
          margin-bottom: 15px;
        }
        .pampas-reviews-section .pampas-reviews-intro h2 {
          font-size: 28px;
        }
        .pampas-reviews-section .pampas-reviews-intro p {
          font-size: 15px;
        }
        .pampas-reviews-section .reputon-header {
          width: calc(100% - 32px) !important;
          margin-bottom: 14px !important;
          padding: 13px 14px !important;
          border-radius: var(--pm-radius-medium) !important;
        }
        .pampas-reviews-manual {
          width: calc(100% - 32px);
          padding: 0;
        }
        .pampas-reviews-track {
          gap: 10px;
          padding-inline: 0;
          scroll-padding-inline: 0;
        }
        .pampas-review-card {
          flex-basis: 100% !important;
          width: 100% !important;
          min-width: 100% !important;
          max-width: 100% !important;
          min-height: 210px !important;
          padding: 16px !important;
          border-radius: var(--pm-radius-medium) !important;
        }
        .pampas-reviews-nav__button {
          width: 42px;
          height: 42px;
        }
      }
      @media (prefers-reduced-motion: reduce) {
        .pampas-reviews-track {
          scroll-behavior: auto;
        }
      }
    `;
    document.head.appendChild(style);
  };

  const photoIcon = `
    <span class="pampas-review-photo-badge" aria-hidden="true">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <rect x="3" y="5" width="18" height="14" rx="2"></rect>
        <circle cx="8.5" cy="10" r="1.5"></circle>
        <path d="m21 15-5-5L5 19"></path>
      </svg>
    </span>`;

  const getSection = () => {
    const widget = document.querySelector(REVIEW_WIDGET_SELECTOR);
    if (!widget) return null;
    return widget.closest('.shopify-section') || widget.closest('[id^="shopify-section"]') || widget.parentElement;
  };

  const isCustomerPhoto = (image) => {
    const context = [
      image.className,
      image.getAttribute('alt'),
      image.parentElement?.className,
      image.parentElement?.parentElement?.className
    ].filter(Boolean).join(' ').toLowerCase();

    if (/avatar|author|profile|business|google|logo|icon/.test(context)) return false;
    if (/review.?photo|review.?image|customer.?photo|media|attachment|photo/.test(context)) return true;

    const card = image.closest('.pampas-review-card');
    return Boolean(card && card.querySelectorAll('img').length > 1);
  };

  const findCustomerMedia = (card) => {
    const image = Array.from(card.querySelectorAll('img')).find(isCustomerPhoto);
    if (image) return image;

    return Array.from(card.querySelectorAll(
      '[style*="background-image"], [class*="review-photo" i], [class*="review-image" i], [class*="attachment" i], [class*="media" i]'
    )).find((element) => {
      const context = [
        element.className,
        element.getAttribute('aria-label'),
        element.parentElement?.className
      ].filter(Boolean).join(' ').toLowerCase();
      return !/avatar|author|profile|business|google|logo|icon/.test(context);
    }) || null;
  };

  const decorateCard = (card) => {
    card.classList.add('pampas-review-card');
    card.removeAttribute('aria-hidden');
    card.querySelectorAll('[aria-hidden="true"]').forEach((element) => {
      if (!element.matches('svg, path')) element.removeAttribute('aria-hidden');
    });

    const media = findCustomerMedia(card);
    if (!media) return false;

    const host = media.closest('a, button, [class*="photo" i], [class*="image" i], [class*="media" i]') || media.parentElement;
    if (!host) return false;

    card.classList.add('has-customer-photo');
    host.classList.add('pampas-review-photo');
    if (!host.querySelector('.pampas-review-photo-badge')) {
      host.insertAdjacentHTML('beforeend', photoIcon);
    }
    return true;
  };

  const getSourceCards = (section) => {
    const cards = [];
    section.querySelectorAll('.reputon-slider').forEach((slider) => {
      const groups = Array.from(slider.children).filter((child) => child.children.length > 0);
      const primaryGroup = groups[0];
      if (!primaryGroup) return;
      Array.from(primaryGroup.children).forEach((card) => cards.push(card));
    });

    const seen = new Set();
    return cards.filter((card) => {
      const text = (card.textContent || '').replace(/\s+/g, ' ').trim();
      if (text.length < 12 || seen.has(text)) return false;
      seen.add(text);
      return true;
    });
  };

  const isRealCustomerReview = (card) => {
    const text = (card.textContent || '').replace(/\s+/g, ' ').trim();
    const context = [
      card.className,
      card.getAttribute('aria-label'),
      text
    ].filter(Boolean).join(' ').toLowerCase();

    if (/\bai\b|בינה מלאכותית|סיכום.*מלאכותי|generated summary|ai summary/.test(context)) {
      return false;
    }
    if (/^\d+\+\s*$/.test(text)) return false;
    return text.length >= 12;
  };

  const addIntro = (section) => {
    if (section.querySelector('.pampas-reviews-intro')) return;
    const appBlock = section.querySelector('.shopify-app-block') || section.firstElementChild;
    if (!appBlock) return;

    const intro = document.createElement('div');
    intro.className = 'pampas-reviews-intro';
    intro.innerHTML = `
      <span class="pampas-reviews-intro__eyebrow">ביקורות אמיתיות</span>
      <h2>מה מספרים עלינו</h2>
      <p>החליקו בין ביקורות הכוללות תמונות אמיתיות ששיתפו לקוחות.</p>`;
    appBlock.before(intro);
  };

  const buildManualReviews = (section) => {
    if (section.querySelector('.pampas-reviews-manual')) return true;

    const sourceCards = getSourceCards(section);
    if (sourceCards.length < 2) return false;

    const entries = sourceCards.filter(isRealCustomerReview).map((source, index) => {
      const card = source.cloneNode(true);
      const hasPhoto = decorateCard(card);
      return { card, hasPhoto, index };
    });
    if (!entries.length) return false;
    entries.sort((a, b) => a.index - b.index);

    const manual = document.createElement('div');
    manual.className = 'pampas-reviews-manual';
    const track = document.createElement('div');
    track.className = 'pampas-reviews-track';
    track.setAttribute('tabindex', '0');
    track.setAttribute('role', 'region');
    track.setAttribute('aria-label', 'ביקורות לקוחות — החליקו ימינה או שמאלה');

    const orderedCards = entries.map((entry) => entry.card);
    orderedCards.forEach((card) => track.append(card));
    manual.append(track);

    const nav = document.createElement('div');
    nav.className = 'pampas-reviews-nav';
    nav.innerHTML = `
      <button class="pampas-reviews-nav__button pampas-reviews-nav__previous" type="button" aria-label="לביקורת הקודמת">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m15 18-6-6 6-6"></path></svg>
      </button>
      <span class="pampas-reviews-status" aria-live="polite">1 / ${orderedCards.length}</span>
      <button class="pampas-reviews-nav__button pampas-reviews-nav__next" type="button" aria-label="לביקורת הבאה">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m9 18 6-6-6-6"></path></svg>
      </button>`;
    manual.append(nav);

    const widget = section.querySelector('.reputon-dual-row-carousel') || section.querySelector('.reputon-carousel-holder');
    if (!widget) return false;
    widget.insertAdjacentElement('afterend', manual);
    section.classList.add('pampas-reviews-ready');

    requestAnimationFrame(() => {
      track.scrollLeft = 0;
    });

    const previous = nav.querySelector('.pampas-reviews-nav__previous');
    const next = nav.querySelector('.pampas-reviews-nav__next');
    const status = nav.querySelector('.pampas-reviews-status');
    const getStep = () => {
      const gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
      return (track.firstElementChild?.getBoundingClientRect().width || track.clientWidth) + gap;
    };
    const updateNavigation = () => {
      const step = getStep();
      const current = Math.max(0, Math.min(orderedCards.length - 1, Math.round(track.scrollLeft / step)));
      status.textContent = `${current + 1} / ${orderedCards.length}`;
      previous.disabled = current === 0;
      next.disabled = current === orderedCards.length - 1;
    };
    previous.addEventListener('click', () => track.scrollBy({ left: -getStep(), behavior: 'smooth' }));
    next.addEventListener('click', () => track.scrollBy({ left: getStep(), behavior: 'smooth' }));
    track.addEventListener('scroll', updateNavigation, { passive: true });
    window.addEventListener('resize', updateNavigation, { passive: true });
    requestAnimationFrame(updateNavigation);

    let autoScrollTimer = 0;
    let autoScrollPaused = false;
    const scheduleAutoScroll = () => {
      window.clearTimeout(autoScrollTimer);
      if (autoScrollPaused || document.hidden || orderedCards.length < 2) return;
      autoScrollTimer = window.setTimeout(() => {
        const step = getStep();
        const current = Math.max(0, Math.min(orderedCards.length - 1, Math.round(track.scrollLeft / step)));
        track.scrollTo({
          left: current >= orderedCards.length - 1 ? 0 : (current + 1) * step,
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
        });
        scheduleAutoScroll();
      }, 5000);
    };
    const pauseAutoScroll = () => {
      autoScrollPaused = true;
      window.clearTimeout(autoScrollTimer);
    };
    const resumeAutoScroll = () => {
      autoScrollPaused = false;
      scheduleAutoScroll();
    };
    manual.addEventListener('mouseenter', pauseAutoScroll);
    manual.addEventListener('mouseleave', resumeAutoScroll);
    manual.addEventListener('focusin', pauseAutoScroll);
    manual.addEventListener('focusout', resumeAutoScroll);
    manual.addEventListener('touchstart', pauseAutoScroll, { passive: true });
    manual.addEventListener('touchend', resumeAutoScroll, { passive: true });
    document.addEventListener('visibilitychange', scheduleAutoScroll);
    scheduleAutoScroll();

    track.addEventListener('keydown', (event) => {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      event.preventDefault();
      const amount = Math.min(300, track.clientWidth * .8);
      track.scrollBy({
        left: event.key === 'ArrowLeft' ? -amount : amount,
        behavior: 'smooth'
      });
    });

    return true;
  };

  const enhanceReviews = () => {
    installStyles();
    const section = getSection();
    if (!section) return false;

    section.classList.add('pampas-reviews-section');
    addIntro(section);
    const hasManualReviews = buildManualReviews(section);
    section.classList.toggle('pampas-reviews-native', !hasManualReviews);
    return hasManualReviews;
  };

  let frame = 0;
  const schedule = () => {
    cancelAnimationFrame(frame);
    frame = requestAnimationFrame(enhanceReviews);
  };

  const start = () => {
    schedule();
    const observer = new MutationObserver(() => {
      if (document.querySelector('.pampas-reviews-manual')) return;
      schedule();
    });
    observer.observe(document.body, { childList: true, subtree: true });
    document.addEventListener('shopify:section:load', schedule);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
